import { FC, Fragment, useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { KeyboardArrowDownRounded as KeyboardArrowDownRoundedIcon } from '@mui/icons-material';
// interfaces, constants, helper
import { formatValue } from 'lib/helper';
import { IngredientType } from 'generated/graphql';
import { IngredientTypeSelectProps, SelectType } from 'interfaces';

const IngredientTypeSelector: FC<IngredientTypeSelectProps> = ({
  name,
  title,
  value,
  handleChange,

  // optional values with default values
  error = false,
  disabled = false,
  margin = 'dense',
  isRequired = false,
  isClearable = false,

  // optional values without default values
  onBlur,
  helperText,
}) => {
  const ingredientTypeOptions = useMemo(() => {
    return Object.values(IngredientType).map((type) => ({
      value: type as string,
      name: formatValue(type as string),
    }));
  }, []);

  return (
    <Autocomplete
      multiple
      id={name}
      disabled={disabled}
      options={ingredientTypeOptions}
      disableClearable={!isClearable} // Now controlled by prop
      popupIcon={<KeyboardArrowDownRoundedIcon />}
      getOptionLabel={(option) => option.name || ''}
      value={value}
      isOptionEqualToValue={({ value: option }, { value }) => value === option}
      onChange={(_, value) => {
        handleChange(value as Array<SelectType>);
      }}
      onBlur={onBlur}
      renderInput={(params) => (
        <TextField
          {...params}
          name={name}
          margin={margin}
          variant="outlined"
          helperText={helperText}
          error={Boolean(error)}
          label={isRequired ? `${title} *` : title}
          InputProps={{
            ...params.InputProps,
            endAdornment: <Fragment>{params.InputProps.endAdornment}</Fragment>,
          }}
        />
      )}
    />
  );
};

export default IngredientTypeSelector;
